import {Box, Typography} from '@mui/material';
import AurButton from '../../../common/aur-button/AurButton';
import {t} from 'i18next';
import AurIcon, {IconColors, IconNames} from '../../../common/aur-icon/AurIcon';
import {ReactComponent as NoTemplateIcon} from '../../../../assests/svg/no-file-folder-icon.svg';

type EmptyTemplateBackgroundProp = {
  startNewGroupHandler: () => void;
  bgColorClassName?: string;
};

const EmptyTemplateBackground = (props: EmptyTemplateBackgroundProp) => {
  return (
    <Box
      className={`empty-saved-searches-group-container ${props.bgColorClassName}`}
    >
      <Box
        className={`${props.bgColorClassName}`}
        sx={{
          justifyContent: 'center',
          display: 'flex',
        }}
      >
        <NoTemplateIcon />
      </Box>
      <Box
        className={`${props.bgColorClassName}`}
        sx={{
          justifyContent: 'center',
          display: 'flex',
        }}
      >
        <Typography className="empty-saved-searches-group-text">
          {t('savedSearchesTemplate.noSavedSearchGroups')}
        </Typography>
      </Box>
      <Box
        className={`empty-saved-searches-group-button-container ${props.bgColorClassName}`}
      >
        <AurButton
          key={0}
          disabled={false}
          type="continue"
          title={t('savedSearchesTemplate.startNewGroup')}
          startIcon={
            <AurIcon
              icon={IconNames.Add}
              color={IconColors.Custom}
              customClassName="icon-white"
            />
          }
          label={t('savedSearchesTemplate.startNewGroup')}
          size="Large"
          onClick={props.startNewGroupHandler}
        />
      </Box>
    </Box>
  );
};

export default EmptyTemplateBackground;
